<app-modal [Modal]="{
    title: 'Selección de usuario',
    closeTitle: true,
    hiddenFooter: true
}">
    <ng-container body>
        <article>
            <div class="container__table">
                <div class="responsive__table">
                    <table mat-table [dataSource]="dataSource || []">
                        <ng-container matColumnDef="col1">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let element" (click)="onSelect(element.user)" style="cursor: pointer; width: 90%;"> {{element.name}} ({{element.user}})</td>
                        </ng-container>

                        <ng-container matColumnDef="col2">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let element" (click)="onSelect(element.user)">
                                <mat-icon style="color: #888888; cursor: pointer;">chevron_right</mat-icon>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="2">
                                <div class="not__found">
                                    <div class="container__img">
                                        <img src="assets/media/svg/buscar.svg">
                                    </div>
                                    <div class="container-label">
                                        <p>No hemos encontrado ningún resultado que coincida con tu búsqueda</p>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <mat-paginator #paginator [length]="totalItems" [showFirstLastButtons]="true" [pageSize]="itemsPerPage" [pageSizeOptions]="[5]" (page)="getPaginator($event)"></mat-paginator>
            </div>
        </article>
    </ng-container>

</app-modal>